import { Component } from '@angular/core';

/**
 * Component for quoter layout
 * @export
 * @class TempQuoterLayoutComponent
 */
@Component({
  selector: 'temp-quoter-layout',
  templateUrl: './temp-quoter-layout.component.html',
  styleUrls: ['./temp-quoter-layout.component.scss'],
})
export class TempQuoterLayoutComponent {}
